export let FONTS = {
  font: '"Roboto", sans-serif',
  declarations: ''
}

try {
  const fontsRewrites = require(`./../apps/${process.env.APP_NAME}/src/constants/fonts.ts`).default

  FONTS = fontsRewrites
} catch (error) {}